const TOKEN_KEY = "access_token";

export function getStoredToken() {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(TOKEN_KEY);
}

export function setStoredToken(token) {
  if (typeof window === "undefined") return;
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

/** Normalize Node (demaxtore) or FastAPI login/me payloads. */
export function normalizeAuthUser(data) {
  if (!data || typeof data !== "object") return null;
  const nested = data.user?.user || data.user;
  const roleRaw = nested?.role ?? data.role;
  const role =
    typeof roleRaw === "string"
      ? roleRaw
      : roleRaw?.name || "customer";

  return {
    user_id: data.user_id || (nested?.id != null ? String(nested.id) : undefined),
    email: data.email || nested?.email,
    name: data.name || nested?.name,
    role,
    email_verified: data.email_verified ?? nested?.isVerified ?? false,
    auth_provider: data.auth_provider || "local",
    profile_image: data.profile_image ?? nested?.avatar ?? null,
    created_at: data.created_at || nested?.createdAt || null,
  };
}
